import React, { useState } from 'react'
import LazyHydration from 'react-lazy-hydration'

import { FilterModalService } from '../containers/FilterModalService'

import { FilterModal } from './FilterModal'

export const FilterModalLoader = () => {
  const [isLoaded, setIsLoaded] = useState<boolean>(false)
  const { shouldRenderFilterModal } = FilterModalService.useContainer()

  if (shouldRenderFilterModal && !isLoaded) setIsLoaded(true)

  return isLoaded ? (
    <LazyHydration whenVisible>
      <FilterModal />
    </LazyHydration>
  ) : null
}
